// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"separator_wrapper__x4sld","body":"separator_body__21fSs"};